module.exports = __webpack_public_path__ + "img/valeryb-min.7522ed55.png";